import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/deezer': {
    width: 576,
    height: 512,
    paths: [{
      d: 'M451.5 244.7v-72.7h124.5v72.7h-124.5zM451.5 70.8h124.5v72.7h-124.5v-72.7zM451.5 345.9v-72.7h124.5v72.7h-124.5zM0 447.1v-72.7h124.5v72.7h-124.5zM150.5 447.1v-72.7h124.5v72.7h-124.5zM301 447.1l0-72.7h124.5v72.7h-124.5zM451.5 447.1v-72.7h124.5v72.7h-124.5zM301 345.9v-72.7h124.5v72.7h-124.5zM150.5 345.9l0-72.7h124.5v72.7h-124.5zM150.5 244.7l0-72.7h124.5v72.7h-124.5z'
    }]
  }
});